import { Section7Images } from 'assets/OurStoryImages/Section7'

export type UserMarketing = {
  title: string
  tagline: string
  subtitle: string
  body: string
  image: string
}

export const section7Data: UserMarketing[] = [
  {
    title: 'Consumer',
    tagline: 'Find the right lawyer, every time.',
    subtitle: 'For consumers and SMEs',
    body: 'Our consumer offering is how we engage with the legal market, generate data and demonstrate the value of its application, raising consumer market confidence in resolving their legal needs whilst establishing our role as the gateway into the legal services professions. Our products include Find a Lawyer to match with regulated lawyers and LegalDocs for streamlined legal document drafting.',
    image: Section7Images.ConsumerUser,
  },
  {
    title: 'Lawyer',
    tagline: 'Be the right lawyer.',
    subtitle: 'For firms and lawyers',
    body: 'Legal Utopia’s AI platform seamlessly generates business. No more time-wasting leads as inquiries are filtered to expertise, practice areas, location and price. Legal Utopia also helps practitioners understand how to improve their offering so more clients find and choose them.',
    image: Section7Images.LawyerUser,
  },
  {
    title: 'Enterprise',
    tagline: 'Legal market intelligence you can rely on.',
    subtitle: 'For enterprises and institutions',
    body: 'Our enterprise offering drives markets, policymakers and businesses to access comprehensive market intelligence and resources enabling leading decision making capabilities and winning decisions that help transform how legal services professions work, regulate, and operate. Our services include market data intelligence, licensing, visualisation, reporting and consultancy.',
    image: Section7Images.EnterpriseUser,
  },
]